var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Dropdown', {
    on: {
      "on-click": _vm.updateI18n
    },
    scopedSlots: _vm._u([{
      key: "list",
      fn: function () {
        return [_c('DropdownMenu', {
          staticStyle: {
            "text-align": "center"
          }
        }, _vm._l(_vm.localeList, function (l) {
          return _c('DropdownItem', {
            key: l,
            attrs: {
              "name": l,
              "divided": ""
            }
          }, [_vm._v("\n        " + _vm._s(_vm.$t(("languageName." + l))) + "\n      ")]);
        }), 1)];
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "languages_box"
  }, [_vm.localText ? _c('span', [_vm._v(_vm._s(_vm.localText))]) : _vm._e()])]);
}
var staticRenderFns = []

export { render, staticRenderFns }